/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ThrivecartService {
    /**
     * Connect a Thrivecart account
     * @param workspaceId Workspace ID is required in every request
     * @param requestBody
     * @returns any Successfully connected a Thrivecart account
     * @throws ApiError
     */
    public static postThrivecart(
        workspaceId: string,
        requestBody: {
            code: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/thrivecart',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * List connected Thrivecart accounts
     * @param workspaceId Workspace ID is required in every request
     * @returns any List connected Thrivecart accounts
     * @throws ApiError
     */
    public static getThrivecart(
        workspaceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/thrivecart',
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Disconnect a Thrivecart account
     * @param id The id of api key
     * @param workspaceId Workspace ID is required in every request
     * @returns any Successfully disconnected a Thrivecart account
     * @throws ApiError
     */
    public static deleteThrivecart(
        id: string,
        workspaceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/thrivecart/{id}',
            path: {
                'id': id,
            },
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Connect a Thrivecart account
     * @param requestBody
     * @returns any Successfully connected a Thrivecart account
     * @throws ApiError
     */
    public static postThrivecartEvents(
        requestBody: Record<string, any>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/thrivecart/events',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error`,
            },
        });
    }
}
